import environment from '../../../../environments/environment';
/**
 * This class holds the complete api urls for various BSSH APIs
 * Can be used when making direct HTTP calls instead of using SDK.
 */
export class PlatformApiEndPoints {
    static session = `${environment.platformUrl}${environment.platformUrl.endsWith('/') ? '' : '/'}Session/`;
}
